
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.908 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.723 5.55c-1.994 1.38-4 2.761-5.983 4.155-.832.574-2.238 1.75-3.273 1.75h-.027c-1.034 0-2.441-1.176-3.273-1.75C6.186 8.312 4.18 6.93 2.199 5.55c-.908-.614-2.2-2.059-2.2-3.221A2.073 2.073 0 012.045.001h18.817a2.061 2.061 0 012.046 2.046 4.622 4.622 0 01-2.185 3.503zm2.185 10.4a2.051 2.051 0 01-2.046 2.046H2.046A2.052 2.052 0 010 15.95V5.805a7.192 7.192 0 001.292 1.113c2.122 1.443 4.269 2.887 6.353 4.41 1.074.792 2.4 1.763 3.8 1.763h.027c1.393 0 2.723-.971 3.8-1.763 2.084-1.51 4.231-2.968 6.366-4.41a7.6 7.6 0 001.279-1.113z"}})])
          )
        }
      }
    